import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errorText } from "@/lib/api";
import { AuthLayout } from "@/components/brand/AuthLayout";
import { Field, FormError, FormSuccess } from "@/components/brand/Field";

export default function ForgotPassword({ admin = false }) {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const base = admin ? "/admin/auth" : "/auth";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(""); setMsg("");
    try {
      await api.post(`${base}/forgot-password`, { email });
      setMsg("If that email exists, a reset link is on its way. It expires in 1 hour.");
    } catch (err) {
      setError(errorText(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthLayout admin={admin} title="Reset your password" subtitle="We'll email you a link. Nothing changes until you choose a new password."
      footer={<Link className="ts-link" to={admin ? "/admin/login" : "/signin"} data-testid="back-to-signin-link">Back to sign in</Link>}>
      <form onSubmit={submit} noValidate>
        <FormSuccess message={msg} testId="forgot-success" />
        <FormError message={error} testId="forgot-error" />
        <Field id="email" label="Email">
          <input id="email" data-testid="forgot-email-input" className="ts-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <button data-testid="forgot-submit-button" className="ts-btn ts-btn-primary w-full" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</button>
      </form>
    </AuthLayout>
  );
}
